import { render, staticRenderFns } from "./InputConfigView.vue?vue&type=template&id=0a430c62"
import script from "./InputConfigView.vue?vue&type=script&lang=js"
export * from "./InputConfigView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports